import { AxiosInstance } from "axios";
import { STORAGE_KEY_AUTH } from "../constants";

export const setupAuthInterceptor = (api: AxiosInstance) => {
	api.interceptors.request.use(
		(config) => {
			const rawAuth = localStorage.getItem(STORAGE_KEY_AUTH);

			if (rawAuth && config.url && !config.url.includes("login")) {
				try {
					const authStorage = JSON.parse(rawAuth);
					const token = authStorage?.token;

					if (token) {
						config.headers.Authorization = `Bearer ${token}`;
					}
				} catch (error) {
					console.warn("Invalid auth object in localStorage:", error);
				}
			}

			return config;
		},
		(error) => Promise.reject(error),
	);
};
